module.exports = "./img/0f5b4b6220f4914ad5d8a9f6fc0b8812.jpg";